export type Point<T> = {
  readonly x: T
  readonly y: T
}
